export default __webpack_public_path__ + "static/media/NuleepFooterLogo.01ae8f93.svg";